export default function toggleListDirective(MapService, MapDrawService, DataService, utils) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/toggle-list/toggle-list-template.html",
		scope: {
			type: "@?",
			heading: "@?",
			list: "=?",
			zoom: "<?",
			map: "=?",
			status: "<?",
			removable: "<?",
			onRemoveItem: "&?",
			icon: "@?",
			onIconClick: "&?",
			empty: "@?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function ($scope) {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				$scope.$watch(() => (vm.list), vm.prefetch);
			};

			vm.prefetch = () => {
				if (vm.zoom && vm.list) {
					vm.list.filter(DataService.hasBoundary).forEach(DataService.loadBounds);
				}
			};

			vm.highlight = (org) => {
				MapDrawService.drawOrgHighlighted(org);
			};

			vm.zoomTo = (org) => {
				DataService.loadBounds(org).then((org) => {
					MapService.centerMap(org, vm.map);
				});
			};

			vm.remove = (org) => {
				utils.removeItem(org, vm.list);
				if (vm.onRemoveItem) {
					vm.onRemoveItem({item: org});
				}
			};
		}
	};
}
